import type React from 'react';

import { ToolIcon } from '@vlabs/icons';
import { TypeCard, TypeIcon } from '@vlabs/monokit/shared/ui/type-card';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath, useHistory } from 'react-router-dom';

import { useCreateHandlerTranslation } from './i18n';

function OtherHandlerCard(): React.JSX.Element {
  const { t } = useCreateHandlerTranslation();
  const history = useHistory();

  return (
    <TypeCard
      data-testid="handler.other"
      description={t('cards.other.description')}
      icon={(
        <TypeIcon>
          <ToolIcon />
        </TypeIcon>
      )}
      onClick={() => history.push(generatePath(routes.handlers.other))}
      title={t('cards.other.title')}
    />
  );
}

export { OtherHandlerCard };
